import { render, staticRenderFns } from "./PageProjects.vue?vue&type=template&id=af247734&"
import script from "./PageProjects.vue?vue&type=script&lang=js&"
export * from "./PageProjects.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports